/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetDriversReportQueryResponse, GetDriversReportQueryParams, GetDriversReport400 } from '../entities/GetDriversReport'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getGetDriversReportUrl() {
  return `/drivers/report` as const
}

/**
 * @description Получение отчета по водителям
 * @summary Получение отчета по водителям
 * {@link /drivers/report}
 */
export async function getDriversReport(params?: GetDriversReportQueryParams, config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<GetDriversReportQueryResponse, ResponseErrorConfig<GetDriversReport400>, unknown>({
    method: 'GET',
    url: getGetDriversReportUrl().toString(),
    params,
    ...requestConfig,
  })
  return res.data
}